<template>
    <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModal('no-comment')">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModal('no-comment')" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('add_comment') }} - {{ trail.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <q-field :helper="$t('how_do_you_rate_this_training')">
                                <q-rating color="amber" v-model="user_stars" :max="5" icon="fas fa-star" size="2rem" :disable="user_disable_comment" :error="$v.user_stars.$error" @input="$v.user_stars.$touch" />
                            </q-field>
                        </div>

                        <div class="col-12">
                            <q-input v-model="user_comment" :float-label="$t('comment')" type="textarea" :max-height="100" rows="3" :disable="user_disable_comment" :error="$v.user_comment.$error" @input="$v.user_comment.$touch" />
                        </div>

                        <div class="col-xs-12 col-sm-4 q-mt-md">
                            <q-btn color="primary" :label="$t('save')" icon="far fa-save" class="full-width" :disable="user_disable_comment" @click="saveComment()">
                                <q-tooltip v-if="user_disable_comment">
                                    {{ $t(motive) }}
                                </q-tooltip>
                            </q-btn>
                        </div>
                    </div>

                    <q-list multiline separator no-border class="q-mt-lg" v-if="comments.length > 0">
                        <q-list-header>{{ $t('recent_comments') }}</q-list-header>

                        <q-item v-for="(comment, index) in comments" :key="index">
                            <q-item-main>
                                <q-item-tile label>
                                    {{ comment.user_name }} <small>{{ $t('in') }} {{ comment.date }}</small>
                                </q-item-tile>
                                <q-item-tile sublabel lines="2">
                                    <p><q-rating color="amber" v-model="comment.stars" :max="5" icon="fas fa-star" :disable="true" /></p>
                                    {{ comment.comment }}
                                </q-item-tile>
                            </q-item-main>
                        </q-item>
                    </q-list>
                </div>
            </q-modal-layout>
        </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import { required } from 'vuelidate/lib/validators'

export default {
    props: ['trail', 'show'],

    data() {
        return {
            user_stars: 0,
            user_comment: '',
            user_disable_comment: true,
            comments: [],
            motive: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_modal: {
            get() {
                return this.show
            },
            set(val) {
                this.comments = []
                this.user_stars = 0
                this.user_comment = ''
                this.user_disable_comment = false
                this.$v.$reset()

                this.$emit('hideModal', 'no-comment')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        fetchComments() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_trails/trails/${this.trail.id}/get_trail_user_stars/`, this.getHeader)
            .then(response => {
                if (response.data.results.trail_user_starred) {
                    this.user_disable_comment = true
                    this.motive = 'you_already_commented'

                    this.user_stars = response.data.results.trail_user_starred.stars
                    this.user_comment = response.data.results.trail_user_starred.comment

                }
                else {
                    if (this.trail.user_progress != 100) this.user_disable_comment = false
                    else {
                        this.motive = 'only_avaliable_when_finish_trail'
                        this.user_disable_comment = true
                    }
                }

                response.data.results.trail_user_stars.forEach(comment => {
                    this.comments.push({
                        stars: comment.stars,
                        user_name: comment.user_name,
                        comment: comment.comment,
                        date: date.formatDate(comment.evaluate_date, 'DD/MM/YYYY HH:mm:ss')
                    })
                })

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        saveComment() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('stars', this.user_stars)
                fd.append('comment', this.user_comment)

                this.$axios.post(`/etraining_trails/trails/${this.trail.id}/set_trail_star/`, fd, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()
                    this.hideModal('commented')
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        hideModal(type) {
            this.comments = []
            this.user_stars = 0
            this.user_comment = ''
            this.user_disable_comment = false
            this.$v.$reset()

            this.$emit('hideModal', type)
        },
    },

    watch: {
        show_modal: function() {
            if (this.show_modal) this.fetchComments()
        }
    },

    validations() {
        return {
            user_stars: { required },
            user_comment: { required }
        }
    }
}
</script>

<style lang="stylus" scoped>
.card-players
    height 600px
    text-align center
</style>
